"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnAAnswerStateDropDown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const answerStateDropdownList = [
    { id: 'select', title: 'supportRoom.answer_state' },
    { id: 'open', title: 'supportRoom.answer_wait' },
    { id: 'closed', title: 'supportRoom.answer_complete' },
];
exports.QnAAnswerStateDropDown = react_1.default.memo(({ answerState, setAnswerState, }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState({
        id: 'select',
        title: 'supportRoom.answer_state',
    });
    react_1.default.useEffect(() => {
        setValue(answerStateDropdownList.find(item => item.id === answerState) ||
            answerStateDropdownList[0]);
    }, [answerState]);
    const handlerUpdateDrop = (item) => {
        setValue(item);
        setAnswerState(item.id);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", list: answerStateDropdownList, value: value, styles: {
            ...(!isMobile && { dropWrap: { width: 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
